// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "dev.auroracloud",
    name: "Aurora Pass",
    homepage: "https://auroracloud.dev/pass",
    image_id: "6d93eeba-edce-431c-4293-e25784e61f00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/aurora-pass-web3-wallet/id6447244286",
        android: "https://play.google.com/store/apps/details?id=aurora.pass.android.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "aurora-pass://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map